import { CSSProperties, StyleSheet } from 'aphrodite';
import { brandPrimaryDark } from '../../styles/colors';
import { baseStyles, CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	userSetupLoading: {
		background: brandPrimaryDark,
		height: '100%',
		position: 'relative',
		...CssSelectors.allChildren(
			{
				...(baseStyles.absoluteCenter as CSSProperties),
			},
			'.loading-spinner'
		),
	},
});
